(function() {
    fetch('https://ipwho.is/')
      .then(function(response) { return response.json(); })
      .then(function(data) {
        console.warn(data);
        var country = data.country_code;
        if (country === 'US') {
          window.location.href = 'https://www.shopforw.com';
        }
      })
      .catch(function(error) {
        // console.log('GeoIP failed', error);
      });
  })();

